import React from 'react';
import { Pie } from '@nivo/pie';
import AutoSizer from 'react-virtualized-auto-sizer';
import { DashboardChartHeader } from './components/chart-header';

function formatData(data) {
  const userSeatRawData = data;

  if (data && Object.keys(data)) {
    const availableSeats =
      (userSeatRawData.user_limit ?? 0) -
      (userSeatRawData.user ?? 0) -
      (userSeatRawData.admin ?? 0) -
      (userSeatRawData.external ?? 0) -
      (userSeatRawData.creator ?? 0);
    let availableSeatPercentage = 0;
    if ((userSeatRawData.user_limit ?? 0) > 0) {
      availableSeatPercentage = availableSeats / userSeatRawData.user_limit;
    }
    return [
      {
        id: 'Creator',
        label: `Creator`,
        value: userSeatRawData.creator ?? 0,
        //color: "rgb(244, 117, 96)",
      },
      {
        id: 'External',
        label: `External`,
        value: userSeatRawData.external ?? 0,
        //color: "rgb(241, 225, 91)",
      },
      {
        id: 'Admin',
        label: `Admin`,
        value: userSeatRawData.admin ?? 0,
        //color: "rgb(232, 168, 56)",
      },
      {
        id: 'User',
        label: `User`,
        value: userSeatRawData.user ?? 0,
        //color: "#61cdbb",
      },
      {
        id: 'Available Seats',
        label: `Available Seats`,
        value: availableSeats,
        //color: "#eeeeee",
      },
    ];
  }
  return [];
}

export function UserSeatChart(props) {
  const [data, setData] = React.useState([]);
  const [userLimit, setUserLimit] = React.useState(0);

  React.useEffect(() => {
    (async () => {
      const rawData = await props.reportClient('/api/v1/analytics/seat-counts');
      const jsonData = await rawData.json();
      const formattedData = formatData(jsonData);
      setUserLimit(jsonData.user_limit);
      setData(formattedData);
    })();
  }, []);

  return (
    <div className="chart-box-flow">
      <div className="chart-box-flow-header" style={{ alignItems: 'start' }}>
        <DashboardChartHeader
          title="Seat Utilization"
          tooltip="Realtime breakdown of user seats."
        />
      </div>
      <div className="chart-box-autosizer-wrapper">
        <AutoSizer>
          {({ width, height }) => (
            <Pie
              data={data}
              width={width}
              height={height}
              margin={{ top: 40, bottom: 20 }}
              innerRadius={0.55}
              padAngle={0.7}
              cornerRadius={0}
              activeOuterRadiusOffset={8}
              // colors={{ scheme: 'paired' }}
              colors={["#BEA7EC", "#F8C98D", "#EA91AD", "#FEA58A", "#4AD3DC"]}
              enableArcLabels={false}
              arcLinkLabelsSkipAngle={10}
              arcLinkLabelsTextColor="#999"
              arcLinkLabelsThickness={2}
              arcLinkLabelsColor={{ from: 'color' }}
              arcLinkLabel={(d) =>
                `${(d.value / userLimit).toLocaleString(undefined, {
                  style: 'percent',
                  minimumFractionDigits: 1,
                })} (${(d.value.toLocaleString(undefined))})`
              }
              arcLabelsSkipAngle={10}
              arcLabelsTextColor={{
                from: 'color',
                modifiers: [['darker', 2]],
              }}
              legends={[
                {
                  anchor: 'top',
                  direction: 'row',
                  justify: false,
                  translateX: 0,
                  translateY: -40,
                  itemsSpacing: 10,
                  itemWidth: 70,
                  itemHeight: 16,
                  itemTextColor: '#999',
                  itemDirection: 'left-to-right',
                  itemOpacity: 1,
                  symbolSize: 8,
                  symbolShape: 'circle',
                  toggleSerie: true,
                  effects: [
                    {
                      on: 'hover',
                      style: {
                        itemTextColor: '#000',
                      },
                    },
                  ],
                },
              ]}
              theme={{
                labels: {
                  text: { fontSize: 10, fontWeight: "bold" }
                },
                legends: {
                  text: { fontSize: 10, fontWeight: "bold" }
                }
              }}
            />
          )}
        </AutoSizer>
      </div>
    </div>
  );
}
